/*
|--------------------------------------------------------------------------
| Utilities: Modal
|--------------------------------------------------------------------------
*/

/**
 * Modal Window
 * Bootstrap JS Modal
 * @namespace
 */
__gh__webApp.utilities.modal = {

	/**
	 * Modal data attributes
	 */
	"dataAttributes": {
		"url": 	"gh-modal-fetch-html-url",
	},


	/**
	 * Modal doms
	 */
	"doms": {
		"modal"				: "#modal-h8f78feh8e7dhsw",
		"modalBody"			: "#modal-h8f78feh8e7dhsw .modal-inner",
		"modalCheckbox"		: "#modal-h8f78feh8e7dhsw input.modal-state",
		"modalCloseButton"	: "#modal-h8f78feh8e7dhsw .modal-close",
		"modalFadeScreen"	: "#modal-h8f78feh8e7dhsw .modal-fade-screen",
		"modalInner"		: "#modal-h8f78feh8e7dhsw .modal-inner",
		"modalOpenClass"	: "modal-open",
	},

	/**
	 * Initialize the modal
	 */
	"init": function() {
		this.bindEvents();
	},


	/**
	 * Add the modal HTML to the body
	 */
	"addModalViewToBody": function(options){
		var modalDOMS 			= __gh__webApp.utilities.modal.doms,
			fetchHandlebarsView = __gh__webApp.utilities.fetch.handlebarsView.get,
			data				= {
				"ghModalObject": JSON.stringify(options)
			};

		// Only get the view if it doesn't exist
		if($(modalDOMS.modal).length == 0){
			var html = fetchHandlebarsView({"view":"utilities/modal","data":data});
			$('body').append(html);
		}
	},


	/**
	 * Callbacks that should run for any modal that opens
	 */
	"callbacks": function(){
		__gh__webApp.utilities.lazyImages.loadAllImages();
	},


	/**
	 * Close the modal
	 */
	"closeModal": function(){
		var modal 			= __gh__webApp.utilities.modal,
			commonJS		= __gh__webApp.common,
			modalDOMS 		= modal.doms,
			ghModalObject	= $(modalDOMS.modal).data("gh-modal-object");
		modal.toggleCheckbox(false);
		$("body").removeClass(modalDOMS.modalOpenClass);
		$(modalDOMS.modalBody).html("");
		if ("closeModalCallback" in ghModalObject){
			commonJS.callFunction(ghModalObject.closeModalCallback);
		}
	},

	/**
	 * Open the modal window
	 * @param {string} - html url to load content from
	 */
	"openModal": function(options){
		var modal 			= __gh__webApp.utilities.modal,
			modalDOMS 		= modal.doms,
			url				= ("url" in options) ? options.url : null;
		modal.addModalViewToBody(options);
		modal.loadContent(url);
		modal.toggleCheckbox(true);
		$("body").addClass(modalDOMS.modalOpenClass);
	},


	/**
	 * Load modal content
	 * @param {string} - html url to load content from
	 */
	"loadContent": function(url){
		var modalDOMS 	= __gh__webApp.utilities.modal.doms;
		//Add Modal Content
		__gh__webApp.utilities.fetch.html.get({
			"url": url,
			"dom": modalDOMS.modalBody,
			"callbacks":[{"callback":"__gh__webApp.utilities.modal.callbacks"}]
		});

	},


	/**
	 * Toggle the modal checkbox
	 * @param {boolean} onOff - set check box to true or false
	 */
	"toggleCheckbox": function(onOff){
		var modalDOMS 	= __gh__webApp.utilities.modal.doms;
		$(modalDOMS.modalCheckbox).prop('checked', onOff);
	},

	/**
	 * Bind the events
	 */
	"bindEvents": function() {
		var modal 				= this,
			modalDOMS			= modal.doms,
			modalDataAttributes = modal.dataAttributes;

		//Open modal
		$(document).on("click", "[data-"+modalDataAttributes.url+"]", function(event) {
			event.preventDefault();
			var $dom			= $(this),
				url				= $dom.data(modalDataAttributes.url);
			modal.openModal({"url":url});
		});

		//Close modal
		$(document).on("click.closeModal", modalDOMS.modalFadeScreen, function(event) {
			event.preventDefault();
			modal.closeModal();
		});


		//Stop event propagation
		$(document).on("click", modalDOMS.modalInner, function(event) {
			event.stopPropagation();
		});

	}
};
